import { render, staticRenderFns } from "./holidaycontent.vue?vue&type=template&id=5b69ee44"
import script from "./holidaycontent.vue?vue&type=script&lang=js"
export * from "./holidaycontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports